
(function() {
  var result = { translations: { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0m", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.1108"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1108",
    "ar-eg": "static-7.1108",
    "bg": "static-7.1108",
    "bn": "static-7.1108",
    "ca-es": "static-7.1108",
    "cs": "static-7.1108",
    "da": "static-7.1108",
    "de": "static-7.1108",
    "el": "static-7.1108",
    "en-gb": "static-7.1108",
    "en": "static-7.1108",
    "es-mx": "static-7.1108",
    "es": "static-7.1108",
    "et": "static-7.1108",
    "fi": "static-7.1108",
    "fr-ca": "static-7.1108",
    "fr": "static-7.1108",
    "he-il": "static-7.1108",
    "hi": "static-7.1108",
    "hr": "static-7.1108",
    "hu": "static-7.1108",
    "id": "static-7.1108",
    "it": "static-7.1108",
    "ja": "static-7.1108",
    "ko": "static-7.1108",
    "lt": "static-7.1108",
    "ms": "static-7.1108",
    "nl": "static-7.1108",
    "no": "static-7.1108",
    "pl": "static-7.1108",
    "pt-br": "static-7.1108",
    "pt-pt": "static-7.1108",
    "ro": "static-7.1108",
    "ru": "static-7.1108",
    "sk": "static-7.1108",
    "sl": "static-7.1108",
    "sv": "static-7.1108",
    "th": "static-7.1108",
    "tl": "static-7.1108",
    "tr": "static-7.1108",
    "uk": "static-7.1108",
    "vi": "static-7.1108",
    "x-pseudo": "static-7.1108",
    "zh-cn": "static-7.1108",
    "zh-hk": "static-7.1108",
    "zh-tw": "static-7.1108"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.1108'}); }
})();


